// src/store/modules/account.js
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import {
    API_LOGIN_INFO,
    APP_LOGIN_FAILURE,
    API_MOBILE_LOGIN_INFO,
    APP_MOBILE_LOGIN_FAILURE
} from '../../../config/mutation-types'

import {
    API_AI
} from '../../../config/const'


const state = {
    apiInfo: '',
    apiMobileInfo: ''
}

const getters = {
    getLogin: state => state.apiInfo,
    getMobileLogin: state => state.apiMobileInfo
}

const actions = {
    getMobileLogin({commit}, options) {
        var uri = API_AI + "/h5/auth/mobileLogin"
        if(options.data.from && options.data.redirect){
            uri += '?from=' + options.data.from + '&redirect=' + options.data.redirect
        }
        return new Promise((resolve, reject) => {
            Vue.http.post(uri,{
                mobilePhone : options.data.mobile,
                validationCode : options.data.msgcode
            }).then((res, err) => {
                    resolve(res.data)
                }, (res) => {
                    reject(res.data)
                })
            }).then((res) => {
                commit(API_MOBILE_LOGIN_INFO, res)
            }, (err) => {
                commit(APP_MOBILE_LOGIN_FAILURE, err + '获取信息失败')
            })
    },
    getLogin({commit}, options) {
        //var uri = "http://192.168.16.149:15005/h5/auth/"
        var uri = API_AI + "/h5/auth"
        if(options.data.from && options.data.redirect){
            uri += '?from=' + options.data.from + '&redirect=' + options.data.redirect
        }
        return new Promise((resolve, reject) => {
            Vue.http.post(uri,{
                username : options.data.username,
                password : options.data.password
            }).then((res, err) => {
                    resolve(res.data)
                }, (res) => {
                    reject(res.data)
                })
            }).then((res) => {
                commit(API_LOGIN_INFO, res)
            }, (err) => {
                commit(APP_LOGIN_FAILURE, err + '获取信息失败')
            })
    }
}

const mutations = {
    [API_LOGIN_INFO](state, data) {
        state.apiInfo = data
    },
    [APP_LOGIN_FAILURE](state, data) {
        state.apiInfo = data
    },
    [API_MOBILE_LOGIN_INFO](state, data) {
        state.apiMobileInfo = data
    },
    [APP_MOBILE_LOGIN_FAILURE](state, data) {
        state.apiMobileInfo = data
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/login/login.js